/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isNodeSchema(data) {
  return data && data.componentName;
}